import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { informesEventoApi } from '../api/informesEvento'
import Boton from '../components/Boton'
import { fmtFecha } from '../utils/fecha'
import { colors, text, radius, sx } from '../design/tokens'

/**
 * Etapa 2.1 — el informe nace sobre el EVENTO: se elige el artículo EVT y
 * LGR trae solas todas sus facturas (etapa 2.2). Los eventos con facturas
 * más recientes van primero.
 */
export default function InformeEventoNuevoPage() {
  const navigate = useNavigate()
  const [q, setQ] = useState('')
  const [eventos, setEventos] = useState([])
  const [cargando, setCargando] = useState(true)
  const [creando, setCreando] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    const t = setTimeout(() => {
      setCargando(true)
      informesEventoApi.eventos(q.trim())
        .then(({ data }) => setEventos(data))
        .catch(() => setError('No se pudieron traer los eventos.'))
        .finally(() => setCargando(false))
    }, 250)
    return () => clearTimeout(t)
  }, [q])

  const elegir = async (ev) => {
    setError(''); setCreando(ev.id)
    try {
      const { data } = await informesEventoApi.crear(ev.id)
      navigate(`/eventos/informes/${data.id}`, { replace: true })
    } catch (err) {
      setError(err.response?.data?.message || 'No se pudo crear el informe.')
      setCreando(null)
    }
  }

  return (
    <div style={{ maxWidth: 980 }}>
      <Boton variante="ghost" sm style={{ marginBottom: 4 }} onClick={() => navigate(-1)}>← Volver</Boton>
      <h1 style={{ margin: '0 0 4px' }}>Nuevo informe de evento</h1>
      <div style={{ fontSize: text.body, color: colors.textSec, marginBottom: 16 }}>
        Elegí el evento (su artículo EVT). Sus comprobantes se cargan solos, estén donde estén: LGR, Presea y la 900.
      </div>

      <input
        autoFocus
        style={{ ...sx.input, width: 360, marginBottom: 12 }}
        placeholder="Buscar por código EVT o nombre del evento..."
        value={q}
        onChange={e => setQ(e.target.value)}
      />
      {error && <div style={{ padding: '10px 14px', borderRadius: 8, marginBottom: 12, background: colors.errBg, color: colors.err }}>{error}</div>}

      <div style={{ background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: radius.lg, overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: text.body }}>
          <thead>
            <tr style={{ background: colors.bgSoft }}>
              <th style={sx.th}>Código</th><th style={sx.th}>Evento</th>
              <th style={{ ...sx.th, textAlign: 'right' }}>Facturas</th><th style={sx.th}>Última factura</th><th style={sx.th}>Acción</th>
            </tr>
          </thead>
          <tbody>
            {cargando && eventos.length === 0 && <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: colors.textMeta }}>Cargando…</td></tr>}
            {!cargando && eventos.length === 0 && <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: colors.textMeta }}>Ningún evento coincide.</td></tr>}
            {eventos.map(ev => (
              <tr key={ev.id} style={{ borderBottom: `1px solid ${colors.borderSoft}` }}>
                <td style={{ padding: '10px 16px', ...sx.mono, whiteSpace: 'nowrap' }}>{ev.codigo}</td>
                <td style={{ padding: '10px 16px' }}>{ev.descripcion}</td>
                <td style={{ padding: '10px 16px', ...sx.mono, textAlign: 'right', whiteSpace: 'nowrap' }}>
                  {ev.facturas}
                  {ev.facturas_900 > 0 && <span style={{ ...sx.badge, background: colors.okBg, color: colors.ok, marginLeft: 6 }} title="Comprobantes de la EMP 900">{ev.facturas_900} de la 900</span>}
                </td>
                <td style={{ padding: '10px 16px', ...sx.mono, color: colors.textSec }}>{ev.ultima_factura ? fmtFecha(ev.ultima_factura) : '—'}</td>
                <td style={{ padding: '10px 16px', whiteSpace: 'nowrap' }}>
                  {ev.informe
                    ? <span style={{ ...sx.badge, background: colors.borderSoft, color: colors.textSub }} title="Este evento ya tiene informe">{ev.informe}</span>
                    : <Boton variante="primary" sm disabled={creando !== null} onClick={() => elegir(ev)}>{creando === ev.id ? 'Creando…' : 'Crear informe'}</Boton>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
